<template>
    <div class="faq-page">
        <div class="ambient-bg">
            <div class="orb-a"></div>
            <div class="orb-b"></div>
            <div class="ambient-grid"></div>
        </div>

        <!-- HERO -->
        <section class="faq-hero">
            <v-container class="faq-container">
                <div class="hero-badge mb-5">
                    <span class="pulse-dot"></span>
                    <span>Frequently asked</span>
                </div>
                <v-row>
                    <v-col cols="12" md="7">
                        <h1 class="display-xl mb-4">
                            Questions about <span class="sophae-grad">Sophae.</span>
                        </h1>
                        <p class="hero-lede">Questions about portfolio monitoring, the evidence it needs, and how to evaluate Sophae with your firm.</p>
                    </v-col>
                    <v-col cols="12" md="5" class="mt-6 mt-md-0">
                        <div class="contact-card">
                            <div class="eyebrow mb-2">Don't see your question?</div>
                            <p class="contact-body">Tell us which portfolio company you have in mind and what you underwrote.</p>
                            <v-btn class="sophae-cta-btn" block @click="onRequestDemo">
                                Request a demo
                                <v-icon right size="18">mdi-arrow-right</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <!-- BODY -->
        <v-container class="faq-container faq-body">
            <!-- CATEGORY FILTER -->
            <section class="faq-categories">
                <v-chip v-for="cat in categories" :key="cat" :outlined="selectedCategory !== cat"
                    class="mr-2 mb-2 cat-chip" :class="{ 'cat-active': selectedCategory === cat }"
                    @click="selectedCategory = cat">
                    {{ cat }}
                </v-chip>
            </section>

            <!-- FAQ LIST -->
            <section class="faq-section">
                <v-expansion-panels multiple accordion>
                    <v-expansion-panel v-for="(item, i) in filteredFaqs" :key="i" class="faq-panel">
                        <v-expansion-panel-header>
                            <div class="d-flex align-center">
                                <span class="cat-tag mr-3">{{ item.category }}</span>
                                <span class="q-text">{{ item.q }}</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <p class="a-text">{{ item.a }}</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <div v-if="!filteredFaqs.length" class="empty">
                    No questions in this category yet.
                </div>
            </section>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'FaqView',
    data() {
        return {
            selectedCategory: 'All',
            categories: [
                'All',
                'Product',
                'Security & data',
                'Deployment',
                'Pricing & ROI',
            ],
            faqs: [
    {
        "category": "Product",
        "q": "What is Sophae?",
        "a": "Sophae is building portfolio-company monitoring for private equity firms, organized around what the firm underwrote and the operating evidence needed to assess it."
    },
    {
        "category": "Product",
        "q": "Who is it for?",
        "a": "PE sponsors and operating partners reviewing the companies they own, alongside portfolio-company management."
    },
    {
        "category": "Product",
        "q": "What does it focus on during ownership?",
        "a": "Whether the operating changes behind the investment thesis are happening, and where the available evidence leaves questions unanswered."
    },
    {
        "category": "Product",
        "q": "How does this differ from reporting?",
        "a": "Reporting shows performance against plan. Sophae focuses on the investment thesis: which assumptions need reviewing, and what evidence is needed to assess them?"
    },
    {
        "category": "Product",
        "q": "Who decides what to do?",
        "a": "The sponsor and management team assess the evidence and decide what action to take."
    },
    {
        "category": "Deployment",
        "q": "Do we need years of deal history?",
        "a": "Start with one portfolio company: its investment thesis, available operating information, and the questions your team needs to assess."
    },
    {
        "category": "Deployment",
        "q": "How would we evaluate it?",
        "a": "Agree the scope and test upfront. Does the review produce relevant questions, evidence your team can assess, and a useful basis for follow-up?"
    },
    {
        "category": "Security & data",
        "q": "How should we approach data and access?",
        "a": "We will discuss your firm’s requirements and the proposed deployment before any data is shared, including access, retention, and permitted use."
    },
    {
        "category": "Pricing & ROI",
        "q": "How is it priced?",
        "a": "Contact us to discuss scope and pricing for your firm."
    }
],
        }
    },
    computed: {
        filteredFaqs() {
            if (this.selectedCategory === 'All') return this.faqs
            return this.faqs.filter(f => f.category === this.selectedCategory)
        },
    },
    methods: {
        onRequestDemo() {
            this.$root.$emit('open-demo')
        },
        onJoinWaitlist() {
            this.$root.$emit('open-waitlist')
        },
        contactUs() {
            window.location.href = 'mailto:hello@sophae.ai?subject=Sophae%20%E2%80%93%20FAQ%20inquiry'
        },
    },
}
</script>
